













import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber
    },
    data: function() {
        return {
            pathInStore: "property.land.depth"
        };
    },
    computed: {
        plotDepth: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(plotDepth: number): void {
            if (plotDepth == 0 && this.$store.getters["FormModule/getValue"](this.pathInStore) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                if (plotDepth != 0) {
                    this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": plotDepth});
                }
            }
        }
    }
});

